// extracted by mini-css-extract-plugin
export var container = "_5l-0";
export var icon = "_5l-1";
export var text = "_5l-2";